import React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Paper } from 'components/UI'
// icons
import SettingsOrigin from '@mui/icons-material/SettingsRounded'
// themes
import { colors } from 'themes/index'

export const TabWrapper = styled(Grid)`
  padding: 20px;
  height: calc(100% - 48px);
`

export const BottomPaper = styled((props) => <Paper square {...props} />)`
  && {
    background: ${colors.gray200};
    padding: 10px 20px;
    margin: ${({ margin }) => margin || '0px -19px -19px'};
  }
`

export const Form = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 12px;
`

export const FormInnerWrapper = styled(({ isDirty, ...props }: any) => <Grid {...props} />)`
  && {
    margin: 0 12px;
    max-width: 1200px;
    ${({ isDirty }) => isDirty && `margin-bottom: 64px`};
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: inherit;
`

export const SettingsIcon = styled((props) => <SettingsOrigin {...props} />)`
  && {
    margin-right: 8px;
  }
`
